import Footer from "./Footer";
import Navbar from "./Navbar";

import "./Terms.css";
import { useEffect } from "react";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const terms = [
    "Customizations must be finalized 7 days before travel",
    "Prices may vary during peak season and holidays",
    "30% advance payment required to confirm booking (*non-refundable)",
    "Final payment due before Check In",
     "Cancellation made less than 3 days before travel may attract 100% charge of the package cost",
    "Custom requests subject to availability",
    "Itinerary changes may affect pricing",
    "Special requests (e.g. dietary, accessibility) must be communicated in advance",
    "Bookings subject to terms of service",
    "Travel insurance recommended",
    "OotyGo not liable for unforeseen circumstances (e.g. weather, strikes)",
    "All bookings subject to availability at time of payment",
    "Prices and inclusions/exclusions subject to change without notice",
    "OotyGo reserves the right to refuse service to anyone",
    "By booking, you agree to OotyGo's full terms and conditions",
    "Travelers must comply with local laws and regulations",
    "OotyGo is not responsible for personal belongings",
    "Health and safety protocols must be followed",
    "Travelers are responsible for their own travel documents (e.g. ID, permits)",
    "OotyGo reserves the right to modify or cancel bookings in case of emergencies",
    "All disputes subject to jurisdiction of Nilgiris courts",
    "OotyGo is committed to sustainable and responsible tourism",
    "By booking, you agree to respect local culture and environment",
    "OotyGo may use photos/videos taken during the trip for promotional purposes unless otherwise requested",
    "For any queries or special requests, please contact us at least 7 days before travel",
    "OotyGo's decision is final in case of any disputes or issues",
    "Additional terms may apply based on specific selections or requests",
  ];

  return (
    <>
      <Navbar solid />
      <div className="Terms_contant">
        <h1>Terms & Conditions</h1>
        <p>Last Updated Date: 10-10-2025, 09.35 Pm</p>
        <div className="booking-terms-container">
          <h2>Booking Terms & Conditions</h2>
          <ul className="booking-terms-list">
            {terms.map((term, index) => (
              <li key={index}>{term}</li>
            ))}
          </ul>
        </div>

        <hr />
        <div className="sla-container">
          <h2>Service Level Agreement (SLA) for OotyGo</h2>

          <h4>Parties Involved:</h4>
          <ul>
            <li>
              <strong>Service Provider:</strong> OotyGo Technologies (
              <a
                href="https://www.ootygo.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.ootygo.in
              </a>
              )
            </li>
            <li>
              <strong>Customers:</strong> All registered users of OotyGo
            </li>
          </ul>

          <h4>1. Purpose</h4>
          <p>
            This SLA outlines the terms and conditions for services provided by
            OotyGo to its customers.
          </p>

          <h4>2. Services Provided</h4>
          <ul>
            <li>
              <strong>Booking Services:</strong> Secure and efficient booking of
              tours, hotels, and taxis.
            </li>
            <li>
              <strong>Customer Support:</strong> Monday to Saturday, 10 AM to 9
              PM for booking-related issues.
            </li>
          </ul>

          <h4>3. Service Availability</h4>
          <ul>
            <li>
              <strong>Uptime Guarantee:</strong> OotyGo guarantees 99.9% uptime
              for its booking platform.
            </li>
            <li>
              <strong>Maintenance:</strong> Scheduled maintenance will be
              communicated at least 48 hours in advance.
            </li>
          </ul>

          <h4>4. Response and Resolution Time</h4>
          <ul>
            <li>
              <strong>Response Time:</strong> All customer inquiries will be
              responded to within 48 hours.
            </li>
            <li>
              <strong>Resolution Time:</strong> Issues will be resolved within
              72 hours from the time of reporting.
            </li>
          </ul>

          <h4>5. Security and Compliance</h4>
          <ul>
            <li>
              <strong>Data Security:</strong> OotyGo complies with GDPR to
              ensure the security of customer data.
            </li>
            <li>
              <strong>Fraud Prevention:</strong> Continuous monitoring and fraud
              detection mechanisms are in place.
            </li>
          </ul>

          <h4>6. Responsibilities</h4>
          <ul>
            <li>
              <strong>OotyGo:</strong> Ensure the platform is operational and
              provide timely support.
            </li>
            <li>
              <strong>Customers:</strong> Provide accurate information and
              comply with the terms of service.
            </li>
          </ul>

          <h4>7. Amendments</h4>
          <p>
            This SLA may be amended with mutual consent of both parties. Any
            amendments will be communicated via email.
          </p>
        </div>
        <hr />
        <div className="privacy-policy-container">
          <h2>Privacy Policy</h2>

          <h4>Introduction</h4>
          <p>
            OotyGo is committed to protecting your privacy. This Privacy Policy
            explains how we collect, use, and safeguard your personal
            information when you visit our website,{" "}
            <a
              href="https://www.ootygo.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ootygo.com
            </a>
            , and use our services.
          </p>

          <h4>Information We Collect</h4>
          <h5>Personal Information</h5>
          <p>
            When you book a tour or travel service, we collect personal
            information such as your name, email address, phone number, and
            payment details.
          </p>

          <h5>Non-Personal Information</h5>
          <p>
            We may collect non-personal information such as your browser type,
            IP address, and browsing behavior on our website.
          </p>

          <h4>How We Use Your Information</h4>
          <h5>To Provide Services</h5>
          <p>
            We use your personal information to process bookings, manage your
            account, and provide customer support.
          </p>

          <h5>To Improve Our Services</h5>
          <p>
            We analyze non-personal information to improve our website and
            services.
          </p>

          <h5>Marketing</h5>
          <p>
            With your consent, we may send you promotional emails about our
            services and special offers.
          </p>

          <h4>Sharing Your Information</h4>
          <h5>Third-Party Service Providers</h5>
          <p>
            We may share your information with third-party service providers who
            assist us in operating our website and providing our services.
          </p>

          <h5>Legal Requirements</h5>
          <p>
            We may disclose your information if required by law or in response
            to legal requests.
          </p>

          <h4>Cookies</h4>
          <p>
            Our website uses cookies to enhance your browsing experience.
            Cookies are small files stored on your device that help us
            understand how you use our website and improve our services.
          </p>

          <h4>Data Security</h4>
          <p>
            We implement appropriate security measures to protect your personal
            information from unauthorized access, alteration, disclosure, or
            destruction.
          </p>

          <h3>Your Rights</h3>
          <h4>Access and Correction</h4>
          <p>
            You have the right to access and correct your personal information.
          </p>

          <h4>Opt-Out</h4>
          <p>
            You can opt-out of receiving marketing emails from us by following
            the unsubscribe link in the emails.
          </p>

          <h4>Changes to This Privacy Policy</h4>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on our website
            or by email.
          </p>

          <h4>Contact Us</h4>
          <p>
            If you have any questions or concerns about this Privacy Policy,
            please contact us at{" "}
            <span style={{ color: "red" }}>
              {" "}
              <b>info@ootygo.com</b>
            </span>
            .
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
